import { createAction, props } from '@ngrx/store';
import { CategoryResponse } from '@app/common/category-response';

export const loadAdminCategories = createAction(
  '[Admin Categories] Load Admin Categories',
  props<{ page: number, size: number, name: string }>()
);

export const loadAdminCategoriesSuccess = createAction(
  '[Admin Categories] Load Admin Categories Success',
  props<{ response: CategoryResponse }>()
);

export const loadAdminCategoriesFailure = createAction(
  '[Admin Categories] Load Admin Categories Failure',
  props<{ error: any }>()
);
